export const i18nGlossary = {
  action_buttons: {
    edit: 'Editar',
    delete: 'Borrar',
    save: 'Guardar',
    cancel: 'Cancelar',
    close: 'Cercar',
  },
  all: {
    all: 'Todos',
    all_male: 'Todos',
    all_female: 'Todas',
  },
  alarm: {
    alarm: 'alarma',
    alarm_one: 'alarma',
    alarm_other: 'alarmas',
  },
  asset: {
    asset: 'equipo',
    asset_one: 'equipo',
    asset_other: 'equipos',
  },
  sensor: {
    sensor: 'sensor',
    sensor_one: 'sensor',
    sensor_other: 'sensores',
  },
  vessel: {
    vessel: 'navío',
    vessel_one: 'navío',
    vessel_other: 'navíos',
  },
  category: {
    category: 'categoria',
    category_one: 'categoria',
    category_other: 'categorias',
  },
  error: {
    title: 'Lo siento por los inconvenientes ocasionados',
    message: 'Ha ocurrido un error inesperado. Por favor inténtalo de nuevo.',
  },
  yes: 'sí',
  no: 'no',
  search: 'Buscar',
  tryAgain: 'Tente novamente',
  system_name: 'Nombre del sistema',
  screen_name: 'Nombre del ecrán',
  alarm_id: 'ID de la alarma',
  home: 'Inicial',
  users_and_permissions: 'Usuarios y permisos',
  tags: 'Etiquetas',
  risk_score: 'Puntuación de riesgo',
  file: { file: 'archivo', file_one: 'archivo', file_other: 'archivos' },
  attachment: { attachment: 'adjunto', attachment_one: 'adjunto', attachment_other: 'adjuntos' },
  comment: { comment: 'comentario', comment_one: 'comentario', comment_other: 'comentarios' },
};
